import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';

import {
  AnimatedContainer,
  Wrapper,
  AnimatedLeftNav,
  AnimatedRightNav,
  LogoLink,
  Logo,
} from './styles';

import AccountDropdown from './AccountDropdown';

import { CONTAINER_ANIMATION, NAVS_ANIMATION } from './animations';

const Header: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <AnimatedContainer
      variants={CONTAINER_ANIMATION}
      initial={pathname === '/dashboard' ? 'unMounted' : 'mounted'}
      animate="mounted"
    >
      <Wrapper>
        <AnimatedLeftNav variants={NAVS_ANIMATION}>
          <LogoLink
            to={{
              pathname: '/dashboard',
            }}
          >
            <Logo />
          </LogoLink>
        </AnimatedLeftNav>

        <AnimatedRightNav variants={NAVS_ANIMATION}>
          <AccountDropdown />
        </AnimatedRightNav>
      </Wrapper>
    </AnimatedContainer>
  );
};

export default memo(Header);
